import React, { useContext, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { UserContext } from '../userContext/UserContext';

const PrivateRoute = ({ children }) => {
    const { isAuthenticated, authReady, loading, sasError, refreshSasToken, setSasError, setAuthReady, resetAuth } = useContext(UserContext);
    const [retryFailed, setRetryFailed] = useState(false);
    const navigate = useNavigate();

    if (loading || (isAuthenticated && !authReady && !sasError)) {
        return <div>Loading...</div>;
    }

    if (isAuthenticated && sasError) {
        const handleRetry = async () => {
            setSasError(false);
            setRetryFailed(false);
            try {
                await refreshSasToken();
                setAuthReady(true);
            } catch (e) {
                setSasError(true);
                setRetryFailed(true);
            }
        };

        const handleSignOut = () => {
            resetAuth();
            navigate('/signin');
        };

        return (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
                <p>Failed to initialize session. Please check your connection and try again.</p>
                <button onClick={handleRetry} style={{ marginTop: '10px', padding: '8px 16px', cursor: 'pointer' }}>
                    Retry
                </button>
                {retryFailed && (
                    <>
                        <p style={{ marginTop: '16px', fontSize: '14px', color: '#666' }}>
                            If this keeps happening, your session may have expired.
                        </p>
                        <button onClick={handleSignOut} style={{ marginTop: '8px', padding: '8px 16px', cursor: 'pointer' }}>
                            Sign in again
                        </button>
                    </>
                )}
            </div>
        );
    }

    return isAuthenticated ? children : <Navigate to="/signin" />;
};

export default PrivateRoute;
